import { createRouter, createWebHistory } from 'vue-router'
import { SESSION_NAME } from '../constant/constantApp'
import { useAppStore } from '../stores/useAppStore.js'
import Api from '../services/api.js'

const appState = useAppStore()
const getSystemApp = async() => {
    try {

        const res = await Api.get('ref/system')
        console.log(res.data)
        appState.setState(res.data)


    } catch (e) {

        appState.app_member_active.value = false;

    }
}
const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import( '../views/auth/Login.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import( '../views/auth/Register.vue')
    },
    {   path: '/403', 
        name: '403',
        meta: { skipAuth: true } ,
        component: () => import( '../views/errors/403.vue')
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        meta: { skipAuth: true } ,
        component: () => import( '../views/errors/Maintenance.vue')
    },
    {   path: '/404', 
        name: '404',
        meta: { skipAuth: true } ,
        component: () => import( '../views/errors/404.vue')
    },
    {
        path: '/',
        name: 'dashboard',
        meta: { requiresAuth: true },
        component: () => import( '../views/Home.vue')
    },
    {
        path: '/promo',
        name: 'promo',
        meta: { requiresAuth: true },
        component: () => import( '../views/promo/Index.vue'),
    },
    {
        path: '/promo/:code/detail',
        name: 'promo.detail',
        meta: { requiresAuth: true },
        component: () => import( '../views/promo/Detail.vue'),
    },
    {
        path: '/shopping',
        name: 'shopping',
        meta: { requiresAuth: true },
        component: () => import( '../views/shopping/Index.vue'),
    },
    {
        path: '/shopping/cart',
        name: 'shopping.cart',
        meta: { requiresAuth: true },
        component: () => import( '../views/shopping/Cart.vue'),
    },
    {
        path: '/shopping/checkout',
        name: 'shopping.checkout',
        meta: { requiresAuth: true },
        component: () => import( '../views/shopping/Checkout.vue'),
    },
    {
        path: '/shopping/:invoice/detail',
        name: 'shopping.detail',
        meta: { requiresAuth: true },
        component: () => import( '../views/shopping/Detail.vue')
    },
    {
        path: '/shopping/:invoice/delivery',
        name: 'shopping.delivery',
        meta: { requiresAuth: true },
        component: () => import( '../views/shopping/DeliveryHistory.vue')
    },
    {
        path: '/:product',
        name: 'product.detail',
        meta: { requiresAuth: true },
        component: () => import( '../views/product/Detail.vue')
    },
    {
        path: '/notification',
        name: 'notification',
        meta: { requiresAuth: true },
        component: () => import( '../views/system/Notif.vue'),
    },
    {
        path: '/session',
        name: 'session',
        meta: { requiresAuth: true },
        component: () => import( '../views/session/Index.vue'),
    },
    {
        path: '/session/:id/detail',
        name: 'session.detail',
        meta: { requiresAuth: true },
        component: () => import( '../views/session/Detail.vue'),
    },
    {
        path: '/activity',
        name: 'activity',
        meta: { requiresAuth: true },
        component: () => import( '../views/activity/Index.vue'),
    },
    {
        path: '/history',
        name: 'history',
        meta: { requiresAuth: true },
        component: () => import( '../views/activity/History.vue'),
    },
    {
        path: '/account',
        name: 'account',
        meta: { requiresAuth: true },
        component: () => import( '../views/account/Index.vue'),
    },
    {
        path: '/account/profile',
        name: 'account.profile',
        meta: { requiresAuth: true },
        component: () => import( '../views/account/Profile.vue'),
    },
    {
        path: '/account/address',
        name: 'account.address',
        meta: { requiresAuth: true },
        component: () => import( '../views/account/Address.vue'),
    },
    {
        path: '/account/setting',
        name: 'account.setting',
        meta: { requiresAuth: true },
        component: () => import( '../views/account/Setting.vue'),
    },
    {
        path: '/account/hutang',
        name: 'account.hutang',
        meta: { requiresAuth: true },
        component: () => import( '../views/account/Hutang.vue'),
    },
    {
        path: '/barcode',
        name: 'barcode',
        meta: { requiresAuth: true },
        component: () => import( '../views/account/Barcode.vue'),
    },
]

//create router
const router = createRouter({
    mode: 'history',
    history: createWebHistory(),
    routes // <-- routes,
})


router.beforeEach(async (to, from, next) => {
    if (!appState.app_member_active.value) {
        await getSystemApp()
    }

    console.log(appState.app_member_active.value)
    if (appState.app_member_active.value && to.name === 'maintenance') {
        return next({ name: 'dashboard' })
    }

    if (!appState.app_member_active.value && to.name !== 'maintenance') {
        return next({ name: 'maintenance' })
    }

    if (to.matched.some(record => record.meta.skipAuth)) {
        return next()
    }

    if (to.meta.requiresAuth) {
        if (localStorage.getItem(SESSION_NAME) !== null) {
            return next()
        }
        return next({ name: 'login' })
    }

    if (localStorage.getItem(SESSION_NAME) !== null) {
        return next({ name: 'dashboard' })
    }

    next()
})

export default router